import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { AppKey } from 'kts-platform-frame/entry/constant';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { history } from 'kts-platform-frame/routes';
import { CSSProperties } from 'react';

class ModulesAction extends ActionBasic<ModulesState> {

    /** 切换收折状态 */
    public switchingCollapsed = () => {
        this.modulesState.collapsed = !this.modulesState.collapsed;
        this.setModulesState(this.modulesState);
    }

    /** 登出用户 */
    public unlogin = () => {
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
        history.push('/login');
    }

    /** app 是否安装 */
    public isInstallApp(appKey: AppKey): boolean {
        const appList: IAppInfo[] = MyStore.instance.getState().system.menuAppList;
        for (let i = 0; appList && i < appList.length; i++) {
            if (appList[i].appKey === appKey as any) {
                return true;
            }
        }
        return false;
    }

    /** 菜单容器的高 */
    public get containerHeight(): number {
        const container = window.document.querySelector('#kes-menu-container');
        return container ? container.clientHeight : 0;
    }

    /** body高度 */
    public get bodyHeight(): number {
        return window.document.body.clientHeight;
    }

    /**
     * 获取菜单选中的状态
     * @param pathname 当前地址栏状态
     */
    public getMenuSelectedKeys(pathname: string): string {

        // 内部APP跟地址
        const selectedKeysList: string[] = [
            '/workbench/invoiceInput',
            '/workbench/platform/inBox/file',
            '/workbench/platform/inBox/message',
            '/workbench/platform/inBox/task',
            '/workbench/platform/inBox/cooperation',
            '/workbench/platform/systemManage',
            '/workbench/myApp',
            '/workbench/platform/appStore/appManagement',
            '/workbench/platform/appStore/appManage',
            '/workbench/platform/help',
            '/workbench/platform/companyinfo',
            '/workbench/platform/document/documentList',
        ];

        for (var i = 0; i < selectedKeysList.length; i++) {
            if (pathname.indexOf(selectedKeysList[i]) === 0) {
                return selectedKeysList[i];
            }
        }

        return pathname;
    }

    /** 设置容器样式 */
    public setMenuStyle = (menuStyle: CSSProperties) => {
        this.modulesState.menuStyle = {
            ...this.modulesState.menuStyle,
            ...menuStyle
        };
        this.setModulesState();
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/Modules.Action.ts